import React from 'react';
import { Link } from 'react-scroll'
import './navigation.scss'
const Navigation = () => {
    return (
        <nav className="navbar navbar-expand navbar-expand-sm navbar-expand-md navbar-expand-lg navbar-light fixed-top">
            <div className="container">
                <div className="navbar-brand">
                    <Link   activeClass="active"
                            to="profile"
                            spy={true}
                            smooth={true}
                            offset={-30}
                            duration= {1000}>Welcome</Link>
                </div>
                <div className="nav">
                    <li className="nav-item nav-link">
                        <Link   activeClass="active"
                                to="about"
                                spy={true}
                                smooth={true}
                                offset={0}
                                duration= {1000}>About</Link>
                    </li>
                    <li className="nav-item nav-link">
                        <Link   activeClass="active"
                                to="portofolio"
                                spy={true}
                                smooth={true}
                                offset={0}
                                duration= {1000}>Experience</Link>
                    </li>
                    <li className="nav-item nav-link">
                        <Link   activeClass="active"
                                to="contact"
                                spy={true}
                                smooth={true}
                                offset={0}
                                duration= {1000}>Contact</Link>
                    </li>
                </div>
            </div>
        </nav>
    );
};

export default Navigation;